import clsx from 'clsx';
import { Link } from 'gatsby';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import React from 'react';
import theme from '../styles/theme.module.scss';
import Asset from './asset';
import masks from './masks.module.scss';
import bgColors from './bg-colors.module.scss';
import styles from './work-projects-grid.module.scss';

function Project(props) {
  const breakpoints = useBreakpoint();

  const heroThumb = props.thumbnailHeroAsset[0] ?? props.thumbnailAsset[0];
  const isHero = !!props.isHero;
  const bgColor = isHero ? props.backgroundColor ?? 'brass' : '';
  const maskingShape = isHero ? props.maskingShape ?? 'bevel' : '';

  const heightHero = 800;
  const widthHero = 1000;
  const heightZero = 480;
  const widthZero = 600;

  return (
    <li
      key={props.id}
      className={clsx(styles.project, theme.mB5, isHero ? styles.hero : styles.zero)}>
      <Link className={styles.project_link} to={`/work/${props.slug.current}`}>
        <div className={clsx(styles.project_assetwrapper, masks[maskingShape], bgColors[bgColor])}>
          {!isHero && (
            <Asset
              asset={props.thumbnailAsset[0]}
              height={heightZero}
              width={widthZero}
              className={styles.entryAsset}
            />
          )}
          {!breakpoints.md && !isHero && (
            <div className={styles.project_hover}>
              <Asset
                asset={props.thumbnailHoverAsset[0]}
                height={heightZero}
                width={widthZero}
                className={styles.entryAsset}
              />
            </div>
          )}
          {isHero && (
            <div className={styles.project_asset}>
              <Asset
                asset={heroThumb}
                height={heightHero}
                width={widthHero}
                className={styles.entryAsset}
              />
            </div>
          )}
          {!breakpoints.md && isHero && (
            <div className={styles.project_hover}>
              <div className={styles.project_hover_inner}>
                <p className={clsx(styles.project_copy, theme.h3_tiempos)}>{props.tagline}</p>
                {props.cta && (
                  <p className={[theme.mT8, theme.h5_founders].join(' ')}>{props.cta}</p>
                )}
              </div>
            </div>
          )}
        </div>

        <div className={styles.project_meta}>
          <h2 className={[styles.project_title, theme.h5_founders].join(' ')}>
            <Link to={`/work/${props.slug.current}`}>{props.title}</Link>
          </h2>
          <ul className={styles.project_cat}>
            {(props.tags ?? []).map((cat, index) => (
              <li key={index}>{cat.value.trim()}</li>
            ))}
            {/* {(props.categories ?? []).map((cat, index) => (
              <li key={index}>{cat.title}</li>
            ))} */}
          </ul>
        </div>
      </Link>
    </li>
  );
}

export default Project;
